import { useEffect, useRef } from "react";

export function BarcodeCamera({ onResult, onError }) {
  const videoRef = useRef(null);
  useEffect(() => {
    let reader = null;
    let mounted = true;
    (async () => {
      try {
        const zx = await import("@zxing/library");
        const hints = new Map();
        hints.set(zx.DecodeHintType.POSSIBLE_FORMATS, [zx.BarcodeFormat.PDF_417]);
        hints.set(zx.DecodeHintType.TRY_HARDER, true);
        reader = new zx.BrowserMultiFormatReader(hints);
        await reader.decodeFromVideoDevice(null, videoRef.current, (res) => {
          if (res && mounted) { mounted = false; onResult(res.getText()); }
        });
      } catch (e) { onError?.(e); }
    })();
    return () => { mounted = false; try { reader?.reset(); } catch (e) { /* noop */ } };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="relative rounded-xl overflow-hidden border-2 border-orange-500/50 bg-black aspect-[4/3]" data-testid="recharge-camera">
      <video ref={videoRef} className="w-full h-full object-cover" muted playsInline />
      <div className="absolute inset-x-6 top-1/2 -translate-y-1/2 h-20 border-2 border-dashed border-orange-400/80 rounded-lg pointer-events-none" />
    </div>
  );
}
